import React from 'react';
export function TomosGrid() {
  const tomos = [{
    num: 1,
    title: 'Entendé tu Metabolismo después de los 40',
    desc: 'Por qué tu cuerpo cambió en la menopausia y cómo reactivar tu metabolismo desde la alimentación.',
    promise: 'Nunca más buscar respuestas sin encontrarlas.'
  }, {
    num: 2,
    title: 'Alimentación Metabólica sin Pasar Hambre',
    desc: 'Qué comer, cuándo y cómo combinarlo. El plato metabólico que activa la quema de grasa.',
    promise: 'Comer bien sin restricciones ni culpa.'
  }, {
    num: 3,
    title: 'Desinflamá tu Cuerpo en 7 Días',
    desc: 'Protocolo antiinflamatorio día a día para eliminar la inflamación silenciosa que frenó todo.',
    promise: 'Los 7 días que cambian todo.'
  }, {
    num: 4,
    title: 'Hormonas, Sueño y Ansiedad',
    desc: 'Cómo la alimentación regula tus hormonas, mejora tu sueño y baja la ansiedad sin medicación.',
    promise: 'Dormí bien, viví mejor.'
  }, {
    num: 5,
    title: 'Plan de 30 Días para Sostener el Resultado',
    desc: 'Cómo pasar de los 7 días al mes completo sin efecto rebote, con menús y listas de compras.',
    promise: 'El resultado que se queda.'
  }, {
    num: 6,
    title: 'Mantenimiento de por Vida',
    desc: 'El método de las 3 fases para mantener el cuerpo nuevo para siempre. Fiestas, viajes, recaídas.',
    promise: 'Tu nueva vida después de los 40.'
  }];
  return <div className="bg-brand-deepInk py-16 px-6" data-id="element-314">
      <div className="max-w-[960px] mx-auto" data-id="element-315">
        <span className="block w-fit bg-brand-green/10 border border-brand-green text-brand-green font-display text-[11px] font-semibold tracking-[2px] py-1.5 px-5 rounded mx-auto mb-4 uppercase" data-id="element-316">
          ✦ 6 TOMOS MAESTROS · EDICIÓN 2026 · +300 PÁGINAS ✦
        </span>
        <h2 className="font-display text-[22px] sm:text-[3.5vw] md:text-[38px] text-center text-white mb-2 uppercase mt-3.5" data-id="element-317">
          El sistema completo para tu cuerpo después de los 40
        </h2>
        <div className="green-divider" data-id="element-318"></div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3.5 mb-7" data-id="element-319">
          {tomos.map(tomo => <div key={tomo.num} className="bg-white/5 border border-brand-border border-t-[3px] border-t-brand-green rounded-lg py-5.5 px-4.5" data-id="element-320">
              <span className="text-[10px] font-bold tracking-[2px] uppercase text-brand-green font-display mb-1.5 block" data-id="element-321">
                Tomo {tomo.num}
              </span>
              <h3 className="font-display text-base text-white mb-2 uppercase leading-tight" data-id="element-322">
                {tomo.title}
              </h3>
              <p className="text-[13px] text-brand-muted mb-2.5 leading-relaxed" data-id="element-323">
                {tomo.desc}
              </p>
              <p className="text-[13px] text-brand-green font-semibold pt-2 border-t border-brand-border" data-id="element-324">
                → {tomo.promise}
              </p>
              <p className="text-[11px] text-[#555] mt-1.5" data-id="element-325">50 páginas</p>
            </div>)}
        </div>

        <div className="bg-brand-green/5 border border-brand-green/20 rounded-lg py-6 px-7" data-id="element-326">
          <p className="font-display text-base text-center text-white mb-4 tracking-[1px] uppercase" data-id="element-327">
            ✦ CADA TOMO INCLUYE ✦
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2" data-id="element-328">
            {['Método probado paso a paso', 'Recetas con ingredientes del súper', 'Adaptable a celíacas y alérgicas', 'Menús semanales listos', 'Checklists de seguimiento', 'Preguntas frecuentes resueltas'].map((item, i) => <div key={i} className="flex items-center gap-2 text-[13px] text-white/75" data-id="element-329">
                <span className="text-brand-green font-bold shrink-0" data-id="element-330">✓</span>
                {item}
              </div>)}
          </div>
        </div>
      </div>
    </div>;
}